import { render } from "./deductStaff.vue?vue&type=template&id=3baab5fa&scoped=true"
import script from "./deductStaff.vue?vue&type=script&lang=js"
export * from "./deductStaff.vue?vue&type=script&lang=js"

import "./deductStaff.vue?vue&type=style&index=0&id=3baab5fa&scoped=true&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3baab5fa"]])

export default __exports__